import { useEffect, useRef } from "react";

export const useScrollToBottomRef = <T extends HTMLElement>(
  scrollOnChangeObject: any
) => {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const el = ref && ref.current;
    if (el && el?.scrollHeight) {
      el.scrollTo(0, el.scrollHeight);
    }
  }, [scrollOnChangeObject]);

  return ref;
};
